<template>
    <div>
        <form-container v-if="!$store.state.local.loader"
                        header-text="Spieler Ummeldung" :width="400" :button-ok="buttonOkText"
                        :button-cancel="buttonCancelText" :button-ok-color="buttonOkColor"
                        :action="action" :valid-actions="['ummeldung']"
                        header-icon="mdi-card-account-details" @save="save()">
            <v-card-text v-if="!sportJahr.ummeldung.ummeldeJahr" >
                Die Fristen sind aktuell abgelaufen, du kannst Spieler erst wieder ab Anfang nächsten Jahres ummelden
                oder im Dezember als Leihspieler melden.
            </v-card-text>
            <v-card-text v-else-if="spieler && pendingAbmeldung" >
                <p>Für Spieler
                    <span class="font-weight-bold warning--text">{{actionObject.spieler.vorname}}
                    {{actionObject.spieler.nachname}}</span>
                    (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
                gibt es einen Antrag auf Abmeldung, der vom Passreferat noch nicht verarbeitet wurde.</p>
                Bitte storniere diese Abmeldung bevor du den Spieler ummeldest!
            </v-card-text>
            <v-card-text v-else-if="!currentMembership" >
                Der Spieler ist aktuell nicht gemeldet, bitte mache eine Neuanmeldung.
            </v-card-text>
            <v-card-text v-else-if="spieler && pendingWiederanmeldung" >
                Du kannst den Spieler erst ummelden, wenn der Passreferent die Wiederanmeldung abgeschlossen hat.
            </v-card-text>
            <v-card-text v-else-if="spieler && pendingPassDuplikat" >
                Du kannst den Spieler nicht ummelden solange du ein Passduplikat angefordert hast.
                Es wird durch die Ummeldung ohnehin ein neuer Pass ausgestellt!
            </v-card-text>
            <v-card-text v-else-if="spieler && pendingUmmeldung" >
                <div>
                    <p>Du hast für Mitglied
                    <span class="font-weight-bold warning--text">{{actionObject.spieler.vorname}}
                    {{actionObject.spieler.nachname}}</span>
                    (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
                    bereits eine Ummeldung auf Verein <span class="font-weight-bold warning--text">
                    {{getNewVereinsNummer(pendingUmmeldung.changes)}}</span> beantragt,
                    die der Passreferent aber noch nicht verarbeitet hat.</p>
                    <p v-if="pendingUmmeldung">Möchtest du diese Ummeldung stornieren?</p>
                </div>
            </v-card-text>
            <v-card-text v-else-if="actionObject && rules " class="px-6"><!--&& vereine.length > 0-->
                <div>Bitte wähle den neuen Verein für Mitglied
                    <span class="font-weight-bold primary--text">{{actionObject.spieler.vorname}}
                    {{actionObject.spieler.nachname}}</span>
                    (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
                    aus:
                </div>
                <div class="mt-6 px-3">
                    <v-row v-if="spieler" >
                        <v-col cols="12" class="px-0 py-0 mb-1">
                            <div class="grey--text caption font-weight-light">Alter Landesverband</div>
                            <div style="border-bottom: solid 1px lightgrey;"
                                 class="grey--text text--darken-0 subtitle-1 mb-3">
                                {{lv.name}}</div>
                        </v-col>
                        <v-col cols="12" class="px-0 py-0 mb-1">
                            <div class="grey--text caption font-weight-light">Alter Verein</div>
                            <div style="border-bottom: solid 1px lightgrey;"
                                 class="grey--text text--darken-0 subtitle-1 mb-3">
                                {{currentVerein.id}} - {{currentVerein.name}}</div>
                        </v-col>
                        <v-col cols="12" class="px-0 py-0">
                            <v-select :items="lvListe" v-model="newLv"
                                      item-text="name" label="Neuer Landesverband"
                                      item-value="id" :rules="[rules.required]">
                            </v-select>
                        </v-col>
                        <v-col cols="12" class="px-0 py-0">
                            <v-select :items="vereinsListe" v-model="newVerein"
                                      item-text="label" label="Neuer Verein"
                                      item-value="id" :rules="[rules.required]">
                            </v-select>
                        </v-col>
                        <v-col cols="12" class="px-0 pt-0 pb-5">
                            <info-line header="Ummeldung ab Sportjahr" style="border-bottom: solid 1px grey">
                                <span class="grey--text text--darken-1">{{sportJahr.ummeldung.ummeldeJahr.text}}</span>
                            </info-line>
                        </v-col>
                        <v-col cols="12" class="px-0 py-0">
                            <v-textarea v-model="actionObject.comment" filled rows="3"
                                        label="Bemerkungen" >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </div>
                <v-alert v-model="showAlert" text color="error" icon="mdi-alert" class="mb-0">
                    Ummeldungen zwischen Landesverbänden sind ausschließlich im Juli möglich!</v-alert>
            </v-card-text>
        </form-container>
    </div>
</template>

<script>
    import FormContainer from "../../../components/form/formContainer";
    import {FormRules} from "../../../services/formRules";
    import {SpielerAction} from "../../../services/data/spielerAction/spielerAction";
    import SPIELER_CHANGE_HANDLER from "../../../services/data/spieler/spielerChangeHandler";
    import SPIELER_MEMBERSHIP_HANDLER from "../../../services/data/spieler/spielerMembershipHandler";
    import TimeStamp from "../../../services/timeStamp";
    import InfoLine from "../../../components/elements/infoLine";
    import Snackbar from "@/components/elements/snackbar";
    import {PassNrService} from "@/services/data/paesse/passNrService";

    export default {
        components: {Snackbar, InfoLine, FormContainer },
        name: "spieler-ummeldung",
        props: ['spieler', 'action', 'actionObject', 'lv'],
        computed: {
            //currentMembership() { return this.spieler ? SPIELER_MEMBERSHIP_HANDLER.getMainMembershipForToday(this.spieler.memberships) : null },
            currentMembership() { return this.spieler ? SPIELER_MEMBERSHIP_HANDLER.getMembershipForTodayOrFuture(this.spieler.memberships) : null },
            currentVerein() {
                if ( !this.currentMembership || !this.lv ||
                     !this.$store.state.realtime.landesverbaende[this.lv.id] ) { return '' }
                let currentVereinNr = this.currentMembership.lvVereinId.substr(2);
                return {id: currentVereinNr,
                        name: this.$store.state.realtime.landesverbaende[this.lv.id] ?
                            this.$store.state.realtime.landesverbaende[this.lv.id].vereine[currentVereinNr].name : ''
                };
            },
            sportJahr(){ return this.$store.state.local.sportJahr; },
            vereine(){
                //return this.$store.getters.getListFromKeys('realtime', 'landesverbaend', 'vereine', 'name');
                return this.newLv && this.$store.state.realtime.landesverbaende[this.newLv] ?
                    this.$store.getters.getListByStoreLink(
                        this.$store.state.realtime.landesverbaende[this.newLv].vereine, 'name') : [];
            },
            lvListe(){
                if ( this.$store.state.user.permissions['lv' + this.lv.id] ) {
                    return this.$store.state.local.landesverbaende
                        .filter( landesverband => landesverband.sportart === this.spieler.sportart);
                } else {
                    let list = [];
                    this.$store.state.local.landesverbaende.forEach( (lv) => {
                        if ( this.$store.state.user.permissions['lv' + lv.id] ) {
                            list.push(lv);
                        }
                    });
                    return list;
                }
            },
            vereinsListe(){
                let list = [];
                this.vereine.forEach( (item) => {
                    if ( this.currentVerein.id !== item.id ) {
                        item.label = item.id + ' - ' + item.name;
                        list.push(item)
                    }
                });
                return list.sort((a, b) => a.label > b.label ? 1 : -1);
            },
            pendingActions() { return this.$store.state.realtime.pendingActions },
            pendingWiederanmeldung(){
                return this.spieler ? this.pendingActions.filter(pendingAction =>
                    pendingAction.search_spieler === this.spieler.id &&
                    pendingAction.actionType === 'wiederanmeldung' ).length > 0 : false;
            },
            pendingAbmeldung(){
                return this.spieler ? this.pendingActions.filter(pendingAction =>
                    pendingAction.search_spieler === this.spieler.id &&
                    pendingAction.actionType === 'abmeldung' ).length > 0 : false;
            },
            pendingPassDuplikat(){
                return this.spieler ? this.pendingActions.filter(pendingAction =>
                    pendingAction.search_spieler === this.spieler.id &&
                    pendingAction.actionType === 'passDuplikat' ).length > 0 : false;
            },
            pendingUmmeldung(){
                return this.spieler ? this.pendingActions.filter(pendingAction =>
                    pendingAction.search_spieler === this.spieler.id &&
                    pendingAction.actionType === 'ummeldung' )[0] : false;
            },
            ummeldungNotPossible(){
                return this.pendingWiederanmeldung || !this.currentMembership ||
                        this.pendingPassDuplikat ||!this.sportJahr.ummeldung.ummeldeJahr;
            },
            buttonOkText(){
                return this.ummeldungNotPossible ? 'ok' : this.pendingUmmeldung ? 'stornieren' : 'speichern';
            },
            buttonOkColor(){
                return this.pendingUmmeldung ? 'warning' : 'primary';
            },
            buttonCancelText(){
                return this.ummeldungNotPossible ?
                        '' : 'abbrechen';
            },
            user(){ return this.$store.state.user; },
        },
        data: () => ({
            rules: null,
            newLv: null,
            newVerein: null,
            showAlert: false,
        }),
        created(){
            this.rules = new FormRules();
            if ( this.$route.query.action ) { console.log ("CREATED FORMCONTAINER" ); window.history.back() }
        },
        methods: {
            async save(){
                this.showAlert = false
            // pending Wiederanmeldung: cancel all
                if ( this.ummeldungNotPossible ) {
                    window.history.back();
                    return;
                }
            // cancel pending Ummeldung
                if ( this.pendingUmmeldung ) {
                    await this.cancelPendingUmmeldung();
                    return;
                }
            // ummeldung LV zur falschen Zeit (nicht Juli!!!)
                const today = TimeStamp.getTodayString();
                if ( this.lv.id !== this.newLv &&
                    today.substring(5,7) !== '07' &&
                    today.substring(5,7) !== '08' &&
                    !this.user?.permissions?.pass ) {
                    this.showAlert = true;
                    return
                }
            // start
                this.$store.state.local.loader = true;
                this.actionObject.setSpielerTemp(this.spieler);
            // new Ummeldung
                // check: has something changed and create an array of all data (field + value)
                    //let currentData = this.$store.getters.getFromRealtimeListById('vereinsspieler', this.spieler.id);
                    if ( this.currentVerein.id !== this.newVerein ) {
                        let lastSportTag = this.spieler.dates.lastSportTag;
                    // log current memberships in actionObject for undo
                        this.actionObject.setUndo({status: this.spieler.status,
                                                   memberships: this.spieler.memberships,
                                                   lvVereinOld: this.currentMembership.lvVereinId});
                    // new 2023 start => passNr für Ummeldungen zwischen LV
                        let newPassNr = ''
                        if ( this.lv.id !== this.newLv ) {
                            const passNrService = new PassNrService(this.newLv, this.spieler.geschlecht)
                            let passNr = await passNrService.getPassNr();
                            newPassNr = passNr.data
                            console.error ("Geschlecht", this.spieler.geschlecht);
                            console.error ("passNr",passNr);
                        }
                        // new 2023 end
                    // log changes in spieler
                        let lvNew = this.lvListe.find( lv => lv.id === this.newLv );
                        this.spieler.local.documentUpdates = SPIELER_CHANGE_HANDLER
                                                        .getDataObjectForUmmeldung( this.spieler, lvNew, this.newVerein, newPassNr);
                        this.spieler.local.documentUpdates.letzteAenderung = TimeStamp.getGMTTimestamp();
                    // log changes in action document
                        this.actionObject.setActionDate(this.$store.state.local.sportJahr.ummeldung.ummeldeJahr.from);
                        this.actionObject.changes.push(
                            {field: 'status', valueOld: this.spieler.status, valueNew: 'aktiv'},
                            {field: 'lvNr', valueOld: this.lv.id, valueNew: this.newLv},
                            {field: 'vereinsNr', valueOld: this.currentVerein.id, valueNew: this.newVerein},
                            {field: 'lastSportTag', valueOld: lastSportTag, valueNew: this.spieler.local.documentUpdates['dates.lastSportTag']}
                        );
                        if ( newPassNr ) {
                            this.actionObject.changes.push(
                                {   field: 'passNr',
                                    valueOld: SPIELER_MEMBERSHIP_HANDLER.getLastValidPassNr(this.spieler.memberships).regular,
                                    valueNew: newPassNr},
                            )
                            console.error ("newPassNr", newPassNr);
                            console.error ("actionObject", this.actionObject.changes);
                        }
                        /*if ( this.newLv !== this.lv.id ) { //new lvNr if ummeldung between lvs
                            this.actionObject.changes.push(
                                {field: 'lvNr', valueOld: this.lv.id, valueNew: this.newLv}
                            );
                        }*/
                    }
            // cancel if no changes
                    if ( this.actionObject.changes.length === 0 ) {
                        this.$emit('actionSnack', {text: 'Du hast keine Daten geändert!', color: 'error'});
                        this.$store.state.local.loader = false;
                        window.history.back();
                        return;
                    }
            // send
                //send spieler
                    await this.spieler.updateWithTransaction('spieler_edit', false);
                // update action to new verein
                    let newLvVerein = this.newLv + '' + this.newVerein; //this.$route.query.id + '' + this.newVerein;
                    this.actionObject.updateLvVerein(this.newLv, newLvVerein, false);
                // send action
                    this.$emit('saveAction', this.actionObject,
                        { success: 'Die Ummeldung war erfolgreich! Du findest das Mitglied ab dem gewählten Sportjahr auch beim neuen Verein!'},
                        true, false, true, false
                    );
            // update all pending actions
                this.updateAllPendingActionsOfSpieler(newLvVerein, false);
                this.$store.state.local.loader = false;
                window.history.back();
            },
            async cancelPendingUmmeldung(){
                    let vereinOld = JSON.parse(JSON.stringify(this.pendingUmmeldung.undo_pending.lvVereinOld));
                    //let lvVerein = this.$route.query.id + '' + this.pendingUmmeldung.changes[0].valueOld;
                    /*let changes = SPIELER_CHANGE_HANDLER.getChangesObjectFromActionItem(this.pendingUmmeldung,
                                    this.lv.id);*/
                // change spieler
                    this.spieler.local.documentUpdates = SPIELER_CHANGE_HANDLER
                                .getDataObjectForUmmeldungCancel( this.pendingUmmeldung, this.spieler);
                    await this.spieler.updateWithTransaction('spieler_edit', false);
                // cancel pending action
                    this.$emit('cancelAction', this.pendingUmmeldung, this.actionObject);
                // update all other pending actions
                    this.updateAllPendingActionsOfSpieler(vereinOld /*changes.vereinOld*/, true);
                    window.history.back();
            },
            updateAllPendingActionsOfSpieler(newLvVerein, clearOld){
                this.pendingActions
                    .filter( pendingAction => pendingAction.search_spieler === this.spieler.id &&
                        pendingAction.actionType !== 'ummeldung')
                    .forEach( (action) => {
                        let actionItem = new SpielerAction(this.spieler, 'ummeldung', this.$route.query.id, this.currentVerein.id);
                        actionItem.setFromDataObject(action);
                        actionItem.updateLvVerein(this.newLv, newLvVerein, clearOld);
                        actionItem.saveEdited('spieler_action_lvVerein');
                    });
            },
            getNewVereinsNummer(pendingUmmeldung){
                if ( !pendingUmmeldung ) return ''
                const lv = pendingUmmeldung.find(item=>item.field === 'lvNr')
                const verein = pendingUmmeldung.find(item=>item.field === 'vereinsNr')
                return lv.valueNew+verein.valueNew
            }
        },
        watch: {
            spieler(){
                if ( this.spieler.private.geburtsdatum === '' ) { this.spieler.setPrivateDataFromDB(); }
                this.newLv = this.lv.id
                this.showAlert = false
            },
            newLv(){
                console.log ("WATCH newLv");
                this.newVerein = null;
                this.$store.dispatch('setVereinslistForLV', {
                    lvId: this.newLv,
                });
            }
        }
    }
</script>

<style scoped>

</style>